import { inject, Injectable } from '@angular/core';
import { EasFormGroup } from './easform';
import { EasField, EasFieldGroup, EasFieldType } from './easform.interfaces';
import { of } from 'rxjs';
import { APIService } from '@fry/lib/api';


@Injectable({
  providedIn: 'root'
})
export class EasFormService {

  api = inject(APIService);

  constructor(

  ) { }

  public createForm(fields: EasField[] | EasFieldGroup, initialValue: any): EasFormGroup {
    let group: EasFieldGroup;

    if (Array.isArray(fields)) {
      group = {
        id: 'root',
        type: EasFieldType.Group,
        fields
      };
    } else {
      group = fields;
    }
    const form = new EasFormGroup(group);
    form.createControl();
    form.setValue(initialValue);
    return form;
  }

  public categoriesSourceFactory(
    sourceUrl: string, sourceFilter?: any, categoriesDependsOn?: string[]
  ) {
    return (_eascontrol, _value, doc, value) => {
      if (value === '') {
        return of([]);
      }

      const data: any = {
        ...(sourceFilter || {}),
        text: value
      };
      (categoriesDependsOn || []).forEach((fieldId: string) => {
        data[fieldId] = doc[fieldId]
      });

      return this.api.post(sourceUrl, data)
    };
  }

  public getInitialFactory(sourceUrl: string, extraCategories?: any[]): (value: string | string[]) => any {
    return (value: string | string[]) => {
      if (!value || value.length === 0) {
        return of([]);
      }
      if (extraCategories) {
        const item = extraCategories.find(itm => itm.id === value);
        if (item) {
          return of([item]);
        }
      }
      return this.api.post(sourceUrl, {
        id: value
      });
    };
  }
}
